// extracted by mini-css-extract-plugin
export default {"root":"_8pqDn","icon":"_1HHr1","text":"MejJ7"};